import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d4b79bb2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "template-view" };
const _hoisted_2 = { class: "template-topbar-container" };
const _hoisted_3 = {
    ref: "templateContainer",
    class: "template-content-container"
};
const _hoisted_4 = { class: "template-container" };
const _hoisted_5 = { class: "template" };
const _hoisted_6 = {
    key: 0,
    class: "circle"
};
const _hoisted_7 = { class: "document-header" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedGetAcceptLogo = _resolveComponent("FriedGetAcceptLogo");
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    const _component_FriedH4 = _resolveComponent("FriedH4");
    const _component_Page = _resolveComponent("Page");
    const _component_SignupTemplateSidebar = _resolveComponent("SignupTemplateSidebar");
    const _component_EngageVideo = _resolveComponent("EngageVideo");
    const _component_Signup = _resolveComponent("Signup");
    const _component_FriedModal = _resolveComponent("FriedModal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FriedGetAcceptLogo, { class: "app-logo" })
        ]),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_FriedSpinner)
                        ]))
                        : (!!_ctx.pages.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_FriedH4, null, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.document.name), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
                                    return (_openBlock(), _createBlock(_component_Page, {
                                        key: page.id,
                                        page: page,
                                        "page-width": _ctx.pageWidth
                                    }, null, 8, ["page", "page-width"]));
                                }), 128))
                            ], 64))
                            : _createCommentVNode("", true)
                ])
            ]),
            _createVNode(_component_SignupTemplateSidebar, {
                class: "signup-template-sidebar hidden-sm-and-down",
                onSignup: _ctx.toggleSignup
            }, null, 8, ["onSignup"]),
            (_ctx.showEngageVideo)
                ? (_openBlock(), _createBlock(_component_EngageVideo, {
                    key: 0,
                    id: _ctx.document.video.video.videoId,
                    url: _ctx.document.video.video.videoUrl,
                    onClose: _ctx.handleCloseEngageVideo
                }, null, 8, ["id", "url", "onClose"]))
                : _createCommentVNode("", true),
            (_ctx.showSignup)
                ? (_openBlock(), _createBlock(_component_FriedModal, {
                    key: 1,
                    class: "modal-backdrop",
                    onClose: _ctx.toggleSignup
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_Signup, {
                            "is-modal": "",
                            "template-id": _ctx.templateId,
                            title: "welcome-to-getaccept-template",
                            "registration-source": "proposal-template",
                            "registration-campaign-id": "globaltemplate",
                            "button-text": "sign-up-template"
                        }, null, 8, ["template-id"])
                    ]),
                    _: 1
                }, 8, ["onClose"]))
                : _createCommentVNode("", true)
        ], 512)
    ]));
}
